<template>
  <div id="fourPart">
    <div class="titlePart">
      <h2 class="title">南京电务段</h2>
      <div class="intro">
          南京电务段主要从事江苏、安徽地区铁路沿线的线路信号设备养护维修工作，下辖16个电务车间、200多个站点，分布范围北至宿州、南至黄山、西至安庆、东至海安。
      </div>
    </div>
    <div class="casebutlist">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list.slice(0, 4)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="imgBox">
      <!-- <Viewer :srcArr="srcListArr" /> -->
      <img src="../../assets/img/case/dwd1.png" alt="" class="innerImg">
    </div>

    <div class="bottomRow">
      <div
        class="countPanel wow animate__zoomIn"
        v-for="(item, index) in bottomPanelData"
        :key="index"
      >
        <div class="panelCount">{{ item.count }}</div>
        <div class="panelTitle">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Viewer from "../viewer/viewer.vue";
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      list: [
        "气体灭火系统",
        "独立感知系统",
        "智慧巡检",
      ],
      srcListArr: [
        {
          src: require("../../assets/img/case/dwd1.png"),
        },
      ],
      bottomPanelData: [
        { count: "200+", desc: "站点" },
        { count: "100+", desc: "主机" },
        { count: "1000+", desc: "消防点位" },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {},
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#fourPart {
  padding: 5% 14%;
  .titlePart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      line-height: 4.2rem;
      margin-bottom: 1rem;
    }
    .intro {
      width: 75%;
      color: #999999;
      text-align: justify;
      text-justify: inter-ideograph; /*IE*/
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
  .casebutlist {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 30%;
    margin: 2rem 0;
    .caseButton {
      background: #ffffff;
      color: #00a087;
      padding: 0.5rem 3rem;
      border-radius: 24px;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.15rem;
      margin: 1rem;
      box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
      cursor: pointer;
    }
  }
  .imgBox {
    margin-bottom: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .innerImg{
        height: 45rem;
    }
  }
  .bottomRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .countPanel {
      background: #ffffff;
      box-shadow: 0px 7px 70px 0px rgba(201, 217, 222, 0.39);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      width: 32%;
      height: 12rem;
      &:hover {
          background: linear-gradient(125deg, #00B7A4, #0DCA81);
        box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
        transform: translate(0, -5px);
        transition: all 0.3s;
        .panelCount {
            color: #ffffff;
        }
        .panelTitle {
            color: #ffffff;
        }
      }
      .panelCount {
        font-weight: bold;
        color: #333333;
        line-height: 2.4rem;
        font-size: 2.4rem;
      }
      .panelTitle {
        color: #999999;
        line-height: 2.4rem;
        font-size: 1.4rem;
        margin-top: 2rem;
        &:hover {
            color: #ffffff;
        }
      }
    }
    .activePanel {
      background: linear-gradient(125deg, #00b7a4, #0dca81);
      box-shadow: 0px 5px 32px 0px rgba(47, 189, 141, 0.34);
      .panelCount,
      .panelTitle {
        color: #ffffff !important;
      }
    }
  }

  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../assets/responsive/case.scss";
</style>
